import styled, { useTheme } from 'styled-components';
import { ButtonMediumSemiText, CaptionSmall } from '../Texts';
import { PHONE_MEDIA_QUERY, useMediaQuery } from '../../common/responsive';
import { hapticsImpactLight } from '../../common/haptic';
import { useSelector } from 'react-redux';
import { selectThemeMode } from '../../redux/slices/themeSlice';

const TabContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 16px;
  width: 100%;
  padding: 5px;
  background-color: ${({ theme }) => theme.background.secondary};
  @media ${PHONE_MEDIA_QUERY} {
    border: unset;
    padding: 0px;
  }
`;

const TabButton = styled.button`
  display: flex;
  padding: 5px 10px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
  height: 50px;
  background: ${({ active, theme, darkMode }) =>
    active
      ? darkMode
        ? theme.primary?.primary
        : theme.primary?.lightest
      : theme.background.secondary};
  color: ${({ active, theme }) =>
    active ? theme.text.title : theme.text.title};

  @media (hover: hover) {
    &:hover {
      background: ${({ active, theme, darkMode }) =>
        active
          ? darkMode
            ? theme.primary?.dark
            : theme.primary?.lightest
          : darkMode
            ? theme.primary?.dark
            : theme.primary?.ultraLight};
    }
  }
`;

const Label = styled.div`
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 3px;
  padding-bottom: 3px;
  justify-content: center;
  align-items: center;
  display: flex;
  border-radius: 999px;
  color: ${({ theme }) => theme.background.primary};
`;

const TabGroup = ({ tabs, activeTab, onTabChange }) => {
  const isMobile = useMediaQuery(PHONE_MEDIA_QUERY);
  const selectedTheme = useSelector(selectThemeMode);
  const theme = useTheme();

  let extraStyles = {};

  if (isMobile) {
    extraStyles = { fontSize: '12px' };
  }

  return (
    <TabContainer>
      {tabs.map((tab) => (
        <TabButton
          darkMode={selectedTheme === 'dark'}
          key={tab.value}
          active={activeTab === tab.value}
          onClick={() => {
            hapticsImpactLight();
            onTabChange(tab.value);
          }}
        >
          {tab?.icon && <img src={tab?.icon} />}
          <ButtonMediumSemiText
            style={{
              textTransform: 'uppercase',
              color:
                selectedTheme === 'dark'
                  ? theme.text.title
                  : theme.text.regular,
              ...extraStyles,
            }}
          >
            {tab.label}
          </ButtonMediumSemiText>
          {tab?.secondaryLabel && !isMobile && (
            <Label>
              <CaptionSmall style={{ color: theme.text.title }}>
                {tab?.secondaryLabel}
              </CaptionSmall>
            </Label>
          )}
        </TabButton>
      ))}
    </TabContainer>
  );
};

export default TabGroup;
